import { http, HttpResponse } from 'msw';
import { DEMO_ORDERS } from '../demo-fixtures';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

export const demoOrdersHandlers = [
  // ── Cross-bot orders list ─────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/orders`, ({ request }) => {
    const url = new URL(request.url);
    const botId = url.searchParams.get('bot_id');
    const statusFilter = url.searchParams.get('status');
    const limit = parseInt(url.searchParams.get('limit') ?? '50', 10);
    const offset = parseInt(url.searchParams.get('offset') ?? '0', 10);

    let items = DEMO_ORDERS as Array<Record<string, unknown>>;

    if (botId) {
      items = items.filter((o) => o['bot_id'] === Number(botId));
    }
    if (statusFilter) {
      items = items.filter((o) => o['status'] === statusFilter);
    }

    const paged = items.slice(offset, offset + limit);
    return HttpResponse.json({
      items: paged,
      total: items.length,
      limit,
      offset,
    });
  }),

  // ── Bot-scoped orders (redirect to same handler) ─────────────────────────
  http.get(`${BASE}/api/v1/bots/:id/orders`, ({ params, request }) => {
    const botId = Number(params['id']);
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '50', 10);
    const offset = parseInt(url.searchParams.get('offset') ?? '0', 10);

    const items = (DEMO_ORDERS as Array<Record<string, unknown>>).filter(
      (o) => o['bot_id'] === botId,
    );
    const paged = items.slice(offset, offset + limit);
    return HttpResponse.json({
      items: paged,
      total: items.length,
      limit,
      offset,
    });
  }),
];
